module.exports = __webpack_public_path__ + "img/mini-logo.3f7e1b04.png";